import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '@/lib/query-client'
import { ThemeProvider } from '@/shared/components/ThemeProvider'
import { AccessibilityProvider } from '@/shared/components/AccessibilityProvider'
import { ErrorBoundary } from '@/shared/components/ErrorBoundary'
import { AuthProvider } from '@/lib/auth-provider'
import router from '@/lib/router'
import './index.css'
import '@/features/jira/styles/jira.css'

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <AccessibilityProvider>
              <RouterProvider router={router} />
            </AccessibilityProvider>
          </ThemeProvider>
        </AuthProvider>
        {/* React Query Devtools - only visible in development */}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
